export default __webpack_public_path__ + "2f5af93b5e52ce27fdcc4c36606bb11c456b8f6426cfc5082a6de523330736d2.png";